import { useTheme } from "next-themes";
import { Toaster as Sonner, toast, ToasterProps } from "sonner";

const Toaster = ({ ...props }: ToasterProps) => {
	const { theme = "system" } = useTheme();
	return (
		<Sonner
			position="top-center"
			theme={theme as ToasterProps["theme"]}
			richColors={false}
			toastOptions={{
				style: {
					backgroundColor: "#000000",
					color: "#FFFFFF",
					border: "1px solid rgba(255, 255, 255, 0.14)",
				},
			}}
			{...props}
		/>
	);
};

const notifySuccess = (title: string, description: string) =>
	toast(title, {
		description,
	});

const notifyError = (title: string, description: string) =>
	toast(title, {
		description,
	});

export { notifyError, notifySuccess, Toaster };
